<template>
    <div class="d-flex certificate-ug2 bg-white w-100">
        <div class="border-ab"></div>
        <div class="border-ab2"></div>
        <div class="c-left">
            <div class="card px-4 my-2">
                <div class="card-header d-flex align-items-center justify-content-between">
                    <img src="../assets/logo_u_galileo.png" class="galileo">
                    <img src="../assets/swisscontactlogo.png" class="swisscontact">
                </div>
                <div class="card-body">
                    <h2 class="pl-4 pr-0 text-uppercase mb-0"><strong>Diploma</strong></h2>
                    <h6 class="pl-4 pr-0 text-uppercase color-ug mt-0 pb-0 montserrat-regular"><strong>de participación</strong></h6>
                    <p class="card-text pl-4 pr-0 py-2 montserrat-medium letter-s1 font-weight-bold">Universidad Galileo y Swisscontact otorgan diploma digital a:</p>
                    <h4 class="pl-4 pr-0 my-2 title-name color-ug font-weight-bold">{{name}} {{lastname}}</h4>
                    <div class="py-2 pl-4 pr-0">
                        <h6>Quien recibió y aprobó el curso:</h6>
                        <h6 class="py-2 letter-s2"><strong>{{course}}</strong></h6>
                    </div>
                    <p class="pl-4 pr-0 text-mini pb-4">Impartido por GalileoX, Iniciativa de aprendizaje en línea de Universidad Galileo.</p>
                    <div class="firm d-flex justify-content-between pl-4 mt-4">
                        <div class="col-3 px-0 text-center">
                            <img src="../assets/manager_firma_rocael.png" alt="" class="signature-img-h">
                            <hr />
                            <h5 class="nombre text-center mb-2">Dr. Rocael Hernández Rizzardini</h5>
                            <h6 class="text-center mb-1">Director del GES</h6>
                            <h6 class="text-center mb-1">Universidad Galileo</h6>
                        </div>
                        <div class="col-4 px-0 text-center">
                            <img src="../assets/manager_firma_kurt.png" alt="" class="signature-img">
                            <hr />
                            <h5 class="nombre text-center mb-2">Kurt Schineider</h5>
                            <h6 class="text-center mb-1">Director de País Swisscontact |</h6>
                            <h6 class="text-center mb-1">Fundación de Suiza de Cooperación para el Desarrollo Técnico</h6>
                        </div>
                    </div>
                    <div class="dp-footer pl-4 mt-4 mb-2 pr-0">
                        <div class="row align-items-center">
                            <div class="col-md-4 ">
                                <p class="text-l"><strong>Diploma verificado</strong></p>
                                <p class="text-l">emitido el {{signDate}}</p>
                            </div>
                            <div class="col-md-4 text-center text-l">
                                <p class="text-l"><strong>Verifica la autenticidad del diploma en</strong></p>
                                <p class="text-l"><span style="font-size:0.6rem">{{verifyUrl}}</span></p>
                            </div>
                            <div class="col-md-4 text-right">
                                <p class="text-l"><strong>Esfuerzo</strong></p>
                                <p class="text-l">{{effort}} horas</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="c-right">
            <svg width="466" height="603" viewBox="0 0 100 100" preserveAspectRatio="none" style="width: 100%;height: 80%;">
            <path d="M0,0 
                    L100,0
                    C25,50 50,75 0,100z" fill="#262226"></path>
            </svg>
        </div>
    </div>
</template>


<script>
export default {
    name: "DefaultTemplate",
    props: {
        name: String,
        lastname: String ,
        course: String,
        signDate: String ,
        verifyUrl: String ,
        effort: String
    }
};
</script>


<style scoped>
.signature-img {
    width: 50%;
    margin-top: -1.9em;
}
.signature-img-h {
    width: 100%;
    margin-top: 1em;
}
.swisscontact{
    width: 200px;
    padding-top: 4.5em;
}
.certificate-ug2 > p {
    margin-bottom: 0;
}
.certificate-ug2 > p,h2,h3,h4,h5,h6 {
    font-family: 'Montserrat', sans-serif;
}
.color-ug {
    color: #b89a59;
}
.shadow-card {
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
}
.card, .card .card-header {
    border-radius: 0;
    border-bottom: 0;
}
.border-ug {
    border: 1px solid #b89a59;
    z-index: 10;
}
.border-ug {
    margin: 10px;
    position: relative;
}
.firm h6, .firm h5 {
    font-size: 14px;
}
.firm h5 {
    font-weight: bold;
}
.firm hr {
    margin-top: .3rem;
    margin-bottom: .3rem;
}
.certificate-ug {
    position: relative;
    margin: 10px;
}
.card {
    width: 100%;
    border: 0;
    z-index: 12;
    background-color: transparent;
}
.card .card-header {
    background: transparent;
}
.item-left, .item-right {
    position: absolute;
    top: 0;
    bottom: 0;
}
.item-left {
    width: 90%;
    background-color: #fff;
    z-index: 9;
    left: 0;
}
.item-right {
    width: 10%;
    background-color: #212529;
    z-index: 9;
    right: 0;
}
.certificate-left {
    width: 90%;
    height: 20px;
    background-color: #fff;;
}
.certificate-right {
    width: 10%;
    height: 20px;
    background-color: #212529;
}
.c-left {
    width: 90%;
}
.c-right {
    width: 10%;
    background-color: #000000;
}
.certificate-ug2 {
    position: relative;
}
.border-ab, .border-ab2 {
    position: absolute;
    width: 97%;
    height: 97%;
    top: 3px;
    left: 6px;
    right: 0px;
    bottom: 0;
    margin: 10px;
    border: 1px solid #b89a59;
    z-index: 11;
}
.border-ab2 {
    top: 14px;
    left: 16px;
    width: 95%;
    height: 94%;
}
.text-mini {
    font-size: 14px;
}
.montserrat-regular {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
}
.montserrat-medium {
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
}
.title-name {
    font-size: calc(14px + (36 - 14) * ((1000px - 500px) / (1600 - 500)));
}
.c-left {
    background-image: url('../assets/background-dp.png');
}
.letter-s1 {
    letter-spacing: 3px;
}
.letter-s2 {
    letter-spacing:  2px;
}
.font-bold {
    font-weight: bold;
}
.text-b {
    font-size: 24px;
}
.text-m {
    font-size: 16px;
}
.text-l {
    font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/templates/DefaultTemplate.vue